import { useCallback, useState } from "react"
import { H2 } from "components/ui/typography/titles/Titles"
import { CompetitorsCollapse } from "./layout/CompetitorsCollapse/CompetitorsCollapse"
import { ButtonSecondary } from "components/ui/buttons/ButtonSecondary/ButtonSecondary"
import { AddCompetitorModal } from "./layout/AddCompetitorModal/AddCompetitorModal"
import style from "./CompetitorsModelNumbers.module.scss"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { AddModelNumberModal } from "./layout/AddModelNumberModal/AddModelNumberModal"
import { InputSearch } from "components/ui/inputs/InputSearch"
import { useDebounce } from "hooks/debounce.hook"
import type { TOnChangeInput } from "types/default.type"

const { competitorsModelNumbers, topBlock, buttonsWrapper, searchBlock, searchField, resultsHint } = style

const SEARCH_DEBOUNCE_MS = 300

export const CompetitorsModelNumbers = () => {
	const [isCompetitorModalOpen, setCompetitorModalOpen] = useState(false)
	const [isModelNumberModalOpen, setModelNumberModalOpen] = useState(false)
	const [searchTerm, setSearchTerm] = useState("")
	const [results, setResults] = useState({ matches: 0, total: 0 })

	// The table is virtualized, so the rows are filtered in the data rather than in the
	// DOM. Debounced because a keystroke re-filters ~2400 rows.
	const debouncedSearchTerm = useDebounce(searchTerm, SEARCH_DEBOUNCE_MS)
	const isSearching = Boolean(debouncedSearchTerm.trim())

	const onResultsChange = useCallback((next: { matches: number; total: number }) => setResults(next), [])

	return (
		<>
			<div className={competitorsModelNumbers}>
				<div className={topBlock}>
					<H2>Competitors model numbers</H2>
					<div className={buttonsWrapper}>
						<ButtonSecondary onClick={() => setCompetitorModalOpen(true)}>Add competitor</ButtonSecondary>
						<ButtonPrimary onClick={() => setModelNumberModalOpen(true)}>Add model number</ButtonPrimary>
					</div>
				</div>
				<div className={searchBlock}>
					<div className={searchField}>
						<InputSearch
							placeholder="Search model number"
							onChange={(event: TOnChangeInput) => setSearchTerm(event.target.value)}
						/>
					</div>
					{isSearching && (
						<span className={resultsHint} data-testid="search-results-hint">
							{results.matches
								? `${results.matches} of ${results.total} model numbers`
								: "No model numbers found"}
						</span>
					)}
				</div>
				<CompetitorsCollapse searchTerm={debouncedSearchTerm} onResultsChange={onResultsChange} />
			</div>
			<AddCompetitorModal isModalOpen={isCompetitorModalOpen} setModalClose={() => setCompetitorModalOpen(false)} />
			<AddModelNumberModal isModalOpen={isModelNumberModalOpen} setModalClose={() => setModelNumberModalOpen(false)} />
		</>
	)
}
